import type { Testimonial } from '@/types/components/testimonial'

export const TESTIMONIALS: Testimonial[] = [
	{
		id: 0,
		user: {
			name: 'Jim S.',
			description: '',
			avatar: {
				src: '',
				alt: 'Jim S.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'I suffered for years with slow internet service and increasing prices from one of the big name providers and now I am more than pleased with Maverix. Speed is great and very dependable.',
		url: 'https://g.co/kgs/fG81BCt'
	},
	{
		id: 1,
		user: {
			name: 'William M.',
			description: '',
			avatar: {
				src: '',
				alt: 'William M.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Excellent customer service and consistent high speed internet',
		url: 'https://g.co/kgs/YeDE9ze'
	},
	{
		id: 2,
		user: {
			name: 'Evrick U.',
			description: '',
			avatar: {
				src: '',
				alt: 'Evrick U.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Very happy with the service customer response when we have had to call in. internet service speeds have been better than our former internet service. Glad we made the switch to Maverix!!',
		url: 'https://g.co/kgs/XUQ25XX'
	},
	{
		id: 3,
		user: {
			name: 'Debbie U.',
			description: '',
			avatar: {
				src: '',
				alt: 'Debbie U.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Maverix has been very receptive to our questions and incredibly helpful on what we need for our new campground. Their technicians on site are always polite and the notifications of when they are enroute is great. We are excited to have Maverix be part of our adventure at Kiowa Outdoor Adventures!',
		url: 'https://g.co/kgs/sSLdKRs'
	},
	{
		id: 4,
		user: {
			name: 'Nate S.',
			description: '',
			avatar: {
				src: '',
				alt: 'Nate S.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'I can\'t say enough good things about Maverix Broadband! From their infrastructure fiber team to their home installers, and to their customer service! If Maverix is in your area, and you don\'t already have them, change!',
		url: 'https://g.co/kgs/sPj8wFB'
	},
	{
		id: 5,
		user: {
			name: 'C D.',
			description: '',
			avatar: {
				src: '',
				alt: 'C D.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'If I could give ten stars, I would!! Excellent service and customer service/response from Maverix Broadband. This company went above and beyond to get my service up before they were ready to go live. That was very much appreciated and unexpected. Internet connectivity is imperative for the work I do, and to have fiber connectivity in this rural location where I live is amazing and next gen! It allows me to work from home seamlessly. I highly recommend Maverix Broadband and can\'t say enough good things about this company!',
		url: 'https://g.co/kgs/gSnfoQV'
	},
	{
		id: 6,
		user: {
			name: 'Susann C.',
			description: '',
			avatar: {
				src: '',
				alt: 'Susann C.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Maverix is truly great! They\'ve really taken a personal application to providing fantastic internet. I would highly recommend them to anyone- great speed and consistency!',
		url: 'https://g.co/kgs/oguZ7NN'
	},
	{
		id: 7,
		user: {
			name: 'Darrell H.',
			description: '',
			avatar: {
				src: '',
				alt: 'Darrell H.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Promises made, promises kept. Maverix was out and buried my fiber line as promised. The guys were great, came up to the house to announce their presence and completed the job very professionally. Thanks again.',
		url: 'https://g.co/kgs/CdhrqNX'
	},
	{
		id: 8,
		user: {
			name: 'Gregg K.',
			description: '',
			avatar: {
				src: '',
				alt: 'Gregg K.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Really went over and above on a difficult install.',
		url: 'https://g.co/kgs/gcRLFQj'
	},
	{
		id: 9,
		user: {
			name: 'Ken S.',
			description: '',
			avatar: {
				src: '/images/testimonials/ken-sasine.jpg',
				alt: 'Ken S.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'We are very happy with our new fiber optic service from Maverix broadband. Great customer service that kept us up-to-date on the progress leading to the final installation. We would gladly recommend our rural neighbors in Elizabeth to switch to Maverix to finally be able to have Internet speeds that are competitive with What has been available In big cities. Well done, Maverix!',
		url: 'https://g.co/kgs/L4hzS2g'
	},
	{
		id: 10,
		user: {
			name: 'Brian M.',
			description: '',
			avatar: {
				src: '',
				alt: 'Brian M.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Out of the Flintstone era into the modern world. Blazing fast speeds and custom service to match. I am so happy. Love living in rural Elizabeth but the one drawback was no fast internet options. Those days are gone. I want to reiterate about how amazing the customer services is. I could not be more pleased with the help that I have received.',
		url: 'https://g.co/kgs/GhjFeLr'
	},
	{
		id: 11,
		user: {
			name: 'Teri A.',
			description: '',
			avatar: {
				src: '',
				alt: 'Teri A.'
			}
		},
		rating: 5,
		highlight: false,
		quote: 'Maverix Broadband has been amazing! They donated equipment and sent their technicians to set up internet so we could keep an eye on our pregnant mare. Then, when our new barn was finished, they jumped right in to move everything over so we could have our cameras and internet running smoothly. The service has been reliable and solid, and it means so much to have a company that truly supports our small nonprofit. Can’t recommend them enough!',
		url: 'https://g.co/kgs/F3CGsJR'
	}
]
